import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiRequest } from 'src/helpers/apiRequest';
import { useAppConfig } from 'src/hooks';
import { TenantEditRequest } from 'src/types/rest/tenant';

export const useEditTenant = (tenantId: string) => {
  const queryClient = useQueryClient();

  const {
    tenancy: { apiHost },
  } = useAppConfig();

  return useMutation({
    mutationFn: (variables: TenantEditRequest) =>
      apiRequest<void>({
        data: variables,
        method: 'PATCH',
        url: `${apiHost}/tenants/${tenantId}`,
      }),
    onSuccess: (variables) => {
      queryClient.setQueryData(['tenant', tenantId], variables);
    },
  });
};
